<template>
  <jczh-drawer
    title="审批详情"
    :visible.sync="visible"
    :direction="direction"
    size="600px"
    @close="handleClose"
    @confirm="confirm"
  >
    <template v-slot:content>
      <div class="card">
        <div class="section">
          <base-section-title class="section-title m-l-0" title="审批信息" />

          <div class="content">
            <span class="m-r-10">流程状态：</span>
            <span v-if="detail.status">
              {{ workflowAuditCheckDict.translate(detail.status).label }}
            </span>
          </div>
          <div class="content">
            <span class="m-r-10">审批标题：</span>
            <span>{{ detail.name }}</span>
          </div>
          <div class="content">
            <span class="m-r-10">审批类型：</span>
            <span
              v-if="detail.businessInfo && detail.businessInfo.businessType"
            >
              {{
                workflowBusinessObject[detail.businessInfo.businessType] +
                  '/' +
                  workflowBusinessObject[detail.businessInfo.businessNode]
              }}
            </span>
          </div>
          <div class="content">
            <span class="m-r-10">发起时间：</span>
            <span v-if="detail.timeInfo && detail.timeInfo.startTime">
              {{ detail.timeInfo.startTime || '-' }}
            </span>
          </div>
          <div class="content">
            <span class="m-r-10">完成时间：</span>
            <span v-if="detail.timeInfo && detail.timeInfo.endTime">
              {{ detail.timeInfo.endTime || '-' }}
            </span>
          </div>
        </div>

        <div class="section">
          <base-section-title class="section-title m-l-0" title="审批流程" />
          <a-steps
            progress-dot
            :current="currentNodeId"
            direction="vertical"
            :style="cssVar"
          >
            <a-step v-for="(item, index) in nodes" :key="index">
              <div slot="title">
                <div>
                  <span class="title">
                    {{ item.title }}
                  </span>
                  <span class="sub-title">
                    {{ item.subTitle }}
                  </span>
                </div>
              </div>
              <div v-if="item.description.length" slot="description">
                <div
                  v-for="(dec, decIndex) in item.description"
                  :key="decIndex"
                >
                  <div
                    v-if="dec.description1 || dec.description2"
                    class="m-t-5"
                  >
                    <span class="text1">{{ dec.description1 }}</span>
                    <span class="text2">{{ dec.description2 }}</span>
                  </div>
                  <div
                    v-if="dec.description3 || dec.description4"
                    class="desc-box"
                  >
                    <div
                      v-if="dec.description3"
                      class="dec-item"
                      :style="{ color: dec.textColor }"
                    >
                      {{ dec.description3 }}
                    </div>
                    <div v-if="dec.description4" class="dec-item">
                      {{ dec.description4 }}
                    </div>
                  </div>
                </div>
              </div>
            </a-step>
          </a-steps>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex row-right" style="width: 100%">
        <el-button
          v-if="isAllowRemark"
          style="width: 120px"
          @click="handleRemark"
        >
          添加审批备注
        </el-button>
        <el-button style="width: 60px" type="primary" @click="handleClose">
          关闭
        </el-button>
        <el-button
          v-if="employeeId === startId && detail.status == 1"
          style="width: 60px"
          @click="revoke"
        >
          撤销
        </el-button>
      </div>

      <!-- 审批备注弹窗 -->
      <remark-dialog
        v-model="remarkVisible"
        :workflow-id="workflowId"
        @complete="completeRemark"
      />
    </template>
  </jczh-drawer>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import RemarkDialog from '@/components/workflow/ApprovalDrawer/RemarkDialog'

// 引入数据字典
import {
  workflowAuditCheckDict,
  workflowAuditMethodDict,
  workflowIdentityDict
} from '@/dictionary/workflow'
// 引入工具函数
import { mapState, mapActions } from 'vuex'
import {
  getWorkflowAuditProgressDetailApi,
  getWorkflowAuditWorkflowDetailApi,
  auditWorkflowRevekeApi,
  getWorkflowRemarksApi
} from '@/api/workflow'
export default {
  name: 'ApprovalDrawer',

  components: {
    BaseSectionTitle,
    RemarkDialog
  },

  model: {
    prop: 'isDrawerShow',
    event: 'change'
  },

  props: {
    // 审核待办事项类型
    isDrawerShow: {
      type: Boolean,
      default: false
    },

    workflowId: {
      type: [Number, String],
      required: true,
      default: ''
    },
    identity: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      direction: 'rtl',
      visible: false,
      reverse: true,
      workflowAuditCheckDict,
      workflowAuditMethodDict,
      workflowIdentityDict,
      currentArr: [],
      workflowInfo: {},
      detail: {},
      startId: '',

      /**
       * 备注弹窗
       */
      remarkVisible: false,

      remarkList: [] // 备注列表
    }
  },
  computed: {
    ...mapState('user', ['employeeId']),
    ...mapState('workflow', ['workflowBusinessObject']),

    nodes() {
      const nodeArr = []
      let newNodeArr = []
      const statusArr = ['审批中', '已同意', '已拒绝']
      const textColorArr = ['#666666', '#52C41A;', '#FF4D4F']
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentArr = []
      let nodeIndex = 0
      if (this.workflowInfo.nodes && this.workflowInfo.nodes.length) {
        this.workflowInfo.nodes.map(item => {
          const obj = {
            title: '',
            description: [],
            subTitle: '',
            status: 0
          }
          this.currentArr.push(item.nodeId)
          if (item.nodeType == 'start') {
            obj.title = this.stringJoinHandel(item.workflowApprovers, 'name')
            obj.subTitle = '发起人' + ' ' + item.timeInfo.endTime
            this.startId = item.workflowApprovers[0].id
            const descObj = {
              description1: '',
              description2: '',
              description3: '发起审批',
              description4: '',
              textColor: '#666666'
            }
            obj.description.push(descObj)
          }
          if (item.nodeType == 'approver' || item.nodeType == 'condition') {
            if (item.tasks && item.tasks.length > 0) {
              item.tasks.map(taskItem => {
                const title0 =
                  item.workflowApprovers.length > 1
                    ? `${item.workflowApprovers.length}人`
                    : ''
                const title1 = `${
                  workflowAuditMethodDict.translate(item.approverMethod).label
                }`
                const title2 =
                  item.status === 0 &&
                  this.workflowInfo.currentNodeId != item.nodeId
                    ? `(待审批)`
                    : `(${statusArr[item.status]})`
                obj.title = `${title0} ${title1} ${title2} `
                if (item.status === 0) {
                  taskItem.assignees.map(assigneesItem => {
                    const descObj = {
                      description1: assigneesItem.assigneeName,
                      description2: taskItem.timeInfo.endTime
                        ? '审批人 ' + taskItem.timeInfo.endTime
                        : '审批人 ',
                      description3:
                        item.status === 0 &&
                        this.workflowInfo.currentNodeId != item.nodeId
                          ? `待审批`
                          : `${statusArr[taskItem.reviewInfo.reviewResult]}`,
                      description4: taskItem.reviewInfo.reviewReason
                        ? `审批原因: ${taskItem.reviewInfo.reviewReason}`
                        : '',
                      textColor: textColorArr[taskItem.reviewInfo.reviewResult]
                    }
                    obj.description.push(descObj)
                  })
                } else {
                  const descObj = {
                    description1: taskItem.status
                      ? taskItem.executorInfo.executorName
                      : taskItem.assignees[0].assigneeName,
                    description2: taskItem.timeInfo.endTime
                      ? '审批人 ' + taskItem.timeInfo.endTime
                      : '审批人 ',
                    description3:
                      item.status === 0 &&
                      this.workflowInfo.currentNodeId != item.nodeId
                        ? `待审批`
                        : `${statusArr[taskItem.reviewInfo.reviewResult]}`,
                    description4: taskItem.reviewInfo.reviewReason
                      ? `审批原因:  ${taskItem.reviewInfo.reviewReason}`
                      : '',
                    textColor: textColorArr[taskItem.reviewInfo.reviewResult]
                  }
                  obj.description.push(descObj)
                }
              })
            } else {
              const title0 =
                item.workflowApprovers.length > 1
                  ? `${item.workflowApprovers.length}人`
                  : ''
              const title1 = `${
                workflowAuditMethodDict.translate(item.approverMethod).label
              }`
              const title2 = `(待审批)`
              obj.title = `${title0} ${title1} ${title2} `
              item.workflowApprovers.map(workflowApproversItem => {
                const descObj = {
                  description1: workflowApproversItem.name,
                  description2: '审批人 ',
                  description3: `待审批`,
                  description4: ''
                  // textColor: textColorArr[workflowApproversItem.reviewInfo.reviewResult],
                }
                obj.description.push(descObj)
              })
            }
          }
          if (item.nodeType == 'copy') {
            // let text = ''
            // const descObj = {
            //   description1: '',
            //   description2: '',
            //   description3: '未读',
            //   description4: '',
            // }
            if (item.tasks && item.tasks.length > 0) {
              item.tasks.map(taskItem => {
                let text = ''
                if (taskItem.reviewInfo.reviewResult === 0) {
                  text = '未读'
                }
                if (taskItem.reviewInfo.reviewResult === 1) {
                  text = '已读'
                }
                const descObj = {
                  description1: '',
                  description2: '',
                  description3: text,
                  description4: ''
                }
                obj.description.push(descObj)
              })
            }
            // obj.description.push(descObj)
            obj.title = this.stringJoinHandel(item.workflowApprovers, 'name')
            obj.subTitle = item?.timeInfo?.startTime
              ? '抄送人 ' + item.timeInfo.startTime
              : '抄送人 '
          }
          obj.status = item.status || 0
          obj.nodeType = item.nodeType
          obj.nodeId = item.nodeId
          nodeArr.push(obj)
        })
        nodeArr.map((nodeItem, index) => {
          if (
            nodeItem.nodeId === this.workflowInfo.currentNodeId &&
            this.workflowInfo.status == 4
          ) {
            nodeIndex = index
          }
        })
        if (nodeIndex) {
          // 若已撤回，删除未走完节点
          newNodeArr = nodeArr.slice(0, nodeIndex + 1)
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.currentArr = this.currentArr.slice(0, nodeIndex + 1)
        } else {
          newNodeArr = JSON.parse(JSON.stringify(nodeArr))
        }
        if (this.workflowInfo.status == 4) {
          const obj = {
            title: this.workflowInfo.nodes[0].workflowApprovers[0].name,
            subTitle:
              '发起人' + ' ' + this.workflowInfo.timeInfo.endTime
                ? this.workflowInfo.timeInfo.endTime
                : '',
            description: [
              {
                description1: '',
                description2: '',
                description3: '已撤回',
                description4: ''
              }
            ],
            nodeId: 'revoke',
            nodeType: 'revoke',
            status: 98
          }
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.currentArr.push(obj.nodeId)
          newNodeArr.push(obj)
        }
        // this.workflowInfo.timeInfo.endTime && this.workflowInfo.status != 4 ? this.workflowInfo.timeInfo.endTime : '',
        const obj = {
          title: '完成审批',
          description: [],
          subTitle: '',
          nodeId: 'end',
          nodeType: 'end',
          status: 99
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.currentArr.push(obj.nodeId)
        newNodeArr.push(obj)
      }
      return newNodeArr
    },

    currentNodeId() {
      if (this.workflowInfo.status == 2) {
        return this.currentArr.length - 1
      } else if (this.workflowInfo.status == 4) {
        return this.currentArr.length - 2
      } else {
        return this.currentArr.indexOf(this.workflowInfo.currentNodeId)
      }
    },

    cssVar() {
      let color = ''
      if (this.nodes && this.nodes.length) {
        this.nodes.map(item => {
          if (this.currentNodeId == this.nodes.length - 1) {
            color = '#1890ff'
          }
          if (item.status == 1 && this.currentNodeId != this.nodes.length - 1) {
            color = '#67c23a'
          }
          if (item.status == 2 && this.currentNodeId != this.nodes.length - 1) {
            color = '#ff2626'
          }
        })
        if (this.workflowInfo.status == 4) {
          color = '#ff2626'
        }
      }
      return {
        '--bgcolor': color
      }
    },

    /**
     * 是否允许备注
     * 发起人&审批中&最多能添加三次审批备注
     */
    isAllowRemark() {
      return (
        this.employeeId === this.startId &&
        this.detail.status == workflowAuditCheckDict.PASS_PENDING.value &&
        this.remarkList?.length < 3
      )
    }
  },

  watch: {
    isDrawerShow() {
      this.visible = this.isDrawerShow
      if (this.visible) {
        this.getWorkflowInfo()
        this.getRemarkInfo()
      }
    },

    workflowId: {
      handler: function(val) {
        if (!val) return
        this.getWorkflowInfo()
        this.getRemarkInfo()
      }
      // immediate: true
    }
  },

  created() {
    this.getWorkflowBusinessDict()
  },

  methods: {
    ...mapActions('workflow', ['getWorkflowBusinessDict']),

    getWorkflowInfo() {
      getWorkflowAuditProgressDetailApi(this.workflowId)
        .then(res => {
          this.workflowInfo = res.data || {}
        })
        .catch(err => {
          this.workflowInfo = {}
          this.$message.error(err?.message)
        })
      getWorkflowAuditWorkflowDetailApi(this.workflowId)
        .then(res => {
          this.detail = res.data || {}
        })
        .catch(err => {
          this.$message.error(err?.message)
        })
    },

    /**
     * 查询备注列表
     */
    getRemarkInfo() {
      getWorkflowRemarksApi(this.workflowId)
        .then(res => {
          this.remarkList = res.data || []
        })
        .catch(err => {
          this.$message.error(err?.message)
        })
    },

    handleClose() {
      this.$emit('change', false)
    },

    confirm() {
      this.handleClose()
    },

    stringJoinHandel(arr, key) {
      const strArr = []
      arr.map(item => {
        strArr.push(item[key])
      })
      return strArr.join(' ')
    },
    revoke() {
      this.$systemConfirm('确定撤销审批？').then(result => {
        if (!result) return
        auditWorkflowRevekeApi({}, this.workflowId)
          .then(res => {
            if (res.code == '0') {
              this.$message.success('操作成功')
              this.handleClose()
              this.$emit('refresh')
            }
          })
          .catch(err => {
            this.$message.error(err?.message)
          })
      })
    },

    // 添加审批备注
    handleRemark() {
      this.remarkVisible = true
    },

    // 完成审批备注
    completeRemark(data) {
      this.handleClose()
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  margin: 10px 0 10px 4px;
}
::v-deep .ant-steps-item-content {
  width: 470px;
}
::v-deep .ant-steps-item-active {
  .ant-steps-item-container {
    .ant-steps-icon-dot {
      background: var(--bgcolor);
      top: 0px;
      left: 0px;
    }
  }
}
.desc-box {
  background: $grey-background-color;
  box-sizing: border-box;
  padding: 6px 8px;
  margin-top: 12px;
}
.title {
  font-size: 16px;
  color: $text-color;
  @include text-bold;
}
.sub-title {
  font-size: 12px;
  color: $third-text-color;
  display: inline-block;
  margin-left: 5px;
}
.text1,
.text2 {
  display: inline-block;
}
.text1 {
  font-size: 14px;
  color: $text-color;
  @include text-bold;
}
.text2 {
  font-size: 12px;
  color: $third-text-color;
  @include text-bold;
  margin-left: 5px;
}
.dec-item {
  line-height: 20px;
}
</style>
